export default __webpack_public_path__ + "static/home_cards_chile-f641e7c1292feffa74a9c06542dd3755.png";